module.exports = __webpack_public_path__ + "img/t3-5.8a7b53ab.svg";